export const AUTH_BASE_PATH = 'auth';
export const DASHBOARD_BASE_PATH = 'dashboard';
export const EDUCATION_BASE_PATH = 'education';
export const STATISTIC_BASE_PATH = 'statistic';
export const FILE_DETAIL_BASE_PATH = 'file-detail';
export const FILES_LIST_BASE_PATH = 'my-files';
export const ADJUSTER_REPORT_BASE_PATH = 'adjuster-report';
export const ICONS_PATH = 'icons';
